import React, { useState } from "react";
import BackLink from "../../shared/BackLink";
import {
  Alert,
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  FormControlLabel,
  Grid,
  LinearProgress,
  Stack,
  Switch,
  TextField,
} from "@mui/material";
import { textFieldProps } from "../../shared/constants";
import { useDocument } from "react-firebase-hooks/firestore";
import { useDb } from "../../../contexts/DatabaseContext";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";

export default function UserCustomAuth() {
  const { userId, msisdn } = useParams();
  const navigate = useNavigate();
  const { getDocRef, collectionNames, updateDocument, setDocument } = useDb();
  const [snapshot, loading, error] = useDocument(
    getDocRef(collectionNames.userMeta, userId)
  );

  const [userSnapshot, userLoading, userError] = useDocument(
    getDocRef(collectionNames.users, userId)
  );
  const [busy, setBusy] = useState(false);
  const [customerPin, setCustomerPin] = useState();
  const [usingCustomAuth, setUsingCustomAuth] = useState(false);

  const userMeta =
    (snapshot && {
      ...snapshot.data(),
      id: snapshot.id,
    }) ||
    {};

  const user =
    (userSnapshot && {
      ...userSnapshot.data(),
      uid: userSnapshot.id,
    }) ||
    {};

  if (loading) {
    return <LinearProgress />;
  }

  if (error) {
    return <Alert severity="error">{error.message}</Alert>;
  }

  const handleSave = async () => {
    setBusy(true);
    try {
      await updateDocument(collectionNames.userMeta, userId, {
        is_custom_auth: usingCustomAuth,
      });
      // TODO: Get the user msisdn
      await setDocument(collectionNames.customAuth, user.phone_number, {
        user_pin: customerPin,
        uid: userId,
      });
      navigate(-1);
    } catch (err) {
      window.alert(err.message);
    }
    setBusy(false);
  };

  return (
    <div>
      <BackLink />
      <Grid container spacing={3}>
        <Grid item xs={12} md={12}>
          <Stack spacing={1}>
            <Card>
              <CardHeader title="User Custom Authentication" />
              <CardContent>
                <FormControlLabel
                  control={
                    <Switch
                      defaultChecked={userMeta.is_custom_auth || false}
                      onChange={(e) => setUsingCustomAuth(e.target.checked)}
                    />
                  }
                  label="Use Custom Authentication"
                />
                {usingCustomAuth && (
                  <TextField
                    {...textFieldProps}
                    label={"Customer PIN"}
                    onChange={(e) => setCustomerPin(e.target.value)}
                    type="number"
                  />
                )}
              </CardContent>
              {usingCustomAuth && (
                <CardActions>
                  <Button variant="contained" onClick={handleSave}>
                    Confirm
                  </Button>
                </CardActions>
              )}
            </Card>
          </Stack>
        </Grid>
      </Grid>
    </div>
  );
}
